import { render, staticRenderFns } from "./MedicalRecord.vue?vue&type=template&id=5ea6bac6&scoped=true&"
import script from "./MedicalRecord.vue?vue&type=script&lang=js&"
export * from "./MedicalRecord.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecord.vue?vue&type=style&index=0&id=5ea6bac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea6bac6",
  null
  
)

export default component.exports